<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "ProductCategoryComponent"
}
</script>

<style scoped></style>
